"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandBase = void 0;
class CommandBase {
    constructor(_payload, _commandMetadata) {
        var _a;
        this._payload = _payload;
        this._commandMetadata = _commandMetadata;
        this._timestamp = (_a = _commandMetadata.timestamp) !== null && _a !== void 0 ? _a : new Date();
    }
    toProps() {
        return this._payload;
    }
    get payload() {
        return this._payload;
    }
    get correlationId() {
        var _a;
        return ((_a = this._commandMetadata.correlationId) !== null && _a !== void 0 ? _a : this._commandMetadata.commandId);
    }
    get id() {
        return this._commandMetadata.commandId;
    }
    get requestedBy() {
        return this._commandMetadata.requestedBy;
    }
    get timestamp() {
        return this._timestamp.getTime();
    }
    get tenantId() {
        return this._commandMetadata.tenantId;
    }
}
exports.CommandBase = CommandBase;
//# sourceMappingURL=command-base.js.map